module.exports = __webpack_public_path__ + "static/media/team-min.3309e6d3.jpg";